module.exports = __webpack_public_path__ + "img/turn-right.ea8cc262.gif";